export enum EEntityTag {
    PHYSICIAN = 1,
    NURSE = 2,
    PATIENT = 3,
    PARAMEDIC = 4,
    COMPANY = 5,
    THIS = 6,
    PAYER = 7,
    SUPPLIER = 8,
    PHARMACY = 9,
    ADMINISTRATIVE = 10,
    AUDITOR = 11,
    PARTNERSHIP = 12,
    OFFICE_AWARE = 13,
    MANAGER = 14,
    VALIDATEAFFILIATE = 15,
    VALIDATEBENEFIT = 16,
    REGISTERBENEFIT = 17,
    MANUALBENEFIT = 18,
    VERIFYWARRANTY = 19,
    MANUALCENSUS = 20,
    IMPORTCONTRACTS = 21,
    REQUIRESTOKEN = 22,
    EXPORTPREINVOICE = 23,
}